const isDebugEnabled = (): boolean =>
  import.meta.env.VITE_CHAT_DEBUG === 'true' || import.meta.env.VITE_DEBUG === 'true';

type LogContext = Record<string, unknown> | undefined;

function withContext(message: string, context?: LogContext): [string, LogContext?] {
  if (!context || Object.keys(context).length === 0) {
    return [message];
  }
  return [message, context];
}

export const logger = {
  debug(message: string, context?: LogContext): void {
    if (!isDebugEnabled()) return;
    const args = withContext(message, context);
    console.debug(...args);
  },
  info(message: string, context?: LogContext): void {
    if (!isDebugEnabled()) return;
    const args = withContext(message, context);
    console.info(...args);
  },
  warn(message: string, context?: LogContext): void {
    const args = withContext(message, context);
    console.warn(...args);
  },
  error(message: string, context?: LogContext): void {
    const args = withContext(message, context);
    console.error(...args);
  },
};
